export const REACT_APP_API_GRAPHQL_URL = 'http://192.168.100.138:4442/graphql';

export const MAPBOX_KEY = 'a'
